import { render } from "./FactoringCompany.vue?vue&type=template&id=00bb379f&ts=true"
import script from "./FactoringCompany.vue?vue&type=script&lang=ts"
export * from "./FactoringCompany.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__